import Component from '@glimmer/component';

import LinksTo from 'ember-route-state/components/links-to.gjs';

import ExpandingBlock from 'rise-ui/components/expanding-block.gjs';
import or from 'rise-ui/helpers/or.js';
import neq from 'rise-ui/helpers/neq.js';
import string from 'rise-ui/helpers/string.js';

export default class CatalogDetailRelatedRecordsComponent extends Component {
  <template>
    {{#let
      @otherRecordsForLocation.length
      @otherRecordsForGenerationEffort.length
      as | hasLocationRecords hasGenerationRecords |
    }}
    {{#if (or hasLocationRecords hasGenerationRecords)}}
      <div class="c-related-links__section">

        {{!-- Related Records --}}
        <h4 class="c-section-title">
          {{string "record-related-records-heading"}}
        </h4>
        {{#if hasLocationRecords}}
          <div class="id-catalog-record__related-to-location-list">
            <ExpandingBlock
              class="id-catalog-record__related-to-location-group"
              @initExpanded={{true}}
              @button={{true}}
              @iconClass="id-catalog-record__related-to-location-expand-icon"
            >
              <:head>
                <span class="c-related-links__title">
                  {{string "record-location-records-heading"}}
                </span>
              </:head>
              <:body>
                <div class="c-related-links__links">
                  {{#each @otherRecordsForLocation as | record |}}
                    {{#if (neq record.id @record.id)}}
                      <div class="c-related-links__link">
                        <LinksTo @route="catalog.record" @model={{record.id}}>
                          {{~record.title~}}
                        </LinksTo>
                      </div>
                    {{/if}}
                  {{/each}}
                </div>
              </:body>
            </ExpandingBlock>
          </div>
        {{/if}}

        {{!-- Records with Same Generation Effort --}}
        {{#if hasGenerationRecords}}
          <div class="id-catalog-record__related-to-generation-list">
            <ExpandingBlock
              class="id-catalog-record__related-to-generation-group"
              @initExpanded={{true}}
              @button={{true}}
              @iconClass="id-catalog-record__related-to-generation-expand-icon"
            >
              <:head>
                <span class="c-related-links__title">
                  {{string "record-generation-effort-records-heading"}}
                </span>
              </:head>
              <:body>
                <div class="c-related-links__links">
                  {{#each @otherRecordsForGenerationEffort as | record |}}
                    <div class="c-related-links__link">
                      <LinksTo @route="catalog.record" @model={{record.id}}>
                        {{~record.title~}}
                      </LinksTo>
                    </div>
                  {{/each}}
                </div>
              </:body>
            </ExpandingBlock>
          </div>
        {{/if}}

      </div>
    {{/if}}
    {{/let}}
  </template>
}
